import {css} from 'styled-components';
const sizes = {    
    mobile: 320,
    table: 768,
    desktop: 1024,
    large: 1440,
};


const media = Object.keys(sizes).reduce((finalMedia, size) => {
    return {
        ...finalMedia,
        [size]: function(...args){
            return css`
                @media(min-width: ${sizes[size]}px){
                    ${css(...args)}
                }        
            `;        
        }
    }
}, {})
export default media;
